import React from 'react'
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowBack } from '@mui/icons-material';
import logo from "../Files/IBG Logo without background.svg";
import logoWhite from "../Files/IBG-Alha Technology Logo white.svg";

interface Props { }

function NotFound(props: Props) {
    const { t } = useTranslation();
    const isDark = document.documentElement.dataset.theme === 'dark';

    return (
        <main className='ibg-notfound'>
            <Link to={"/"} className='ibg-notfound__logo'><img src={isDark ? logoWhite : logo} alt="IBG Alpha Technology" /></Link>
            <div className='ibg-notfound__content'>
                <span className='ibg-notfound__code'>404</span>
                <h1 className='ibg-h2'>{t("Pages.notFoundTitle")}</h1>
                <p className='ibg-lead'>{t("Pages.notFoundText")}</p>
                <Link className='ibg-btn ibg-btn--primary' to={"/"}><ArrowBack fontSize='small' /> {t("Pages.notFoundCta")}</Link>
            </div>
        </main>
    )
}

export default NotFound
